
export default function useImageServer() {

  const getPathImageServer = (originalPath?: string) => {
    let alternativePath = process.env.IMAGE_SERVER_URL || 'https://d3kmii4w6wpxh9.cloudfront.net';
    return originalPath ? originalPath.replace(/^https?:\/\/[^/]+/, alternativePath) : '';
  }

  return {
    getPathImageServer
  }
}
